<template>
  <div class="initial-setup-container">
    <!-- <SideBar class="sidebar" /> -->
    <div class="content">
      <StepOne
        @updateStep="handleStepUpdate"
        @topicSelected="handleTopicSelected"
        @submitComplete="handleSubmitComplete"
      />
    </div>
  </div>
</template>

<script>
import StepOne from "@/components/setup/StepOne.vue";

export default {
  components: {
    StepOne,
  },
  data() {
    return {
      currentStep: 1,
      selectedTopic: null,
    };
  },
  methods: {
    handleStepUpdate(step) {
      this.currentStep = step;
    },
    handleTopicSelected(topic) {
      this.selectedTopic = topic;
    },
    handleSubmitComplete() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.initial-setup-container {
  display: flex;
}

.content {
  flex-grow: 1;
}
</style>
